import styled from 'styled-components';
import CompletedActiveSvg from '../../assets/mytrips/completed-active.svg';

const CompletedActiveIcon = styled(CompletedActiveSvg as React.SFC<React.SVGProps<SVGSVGElement>>)`
  width: ${props => props.width || '3.2rem'};
  height: ${props => props.height || '2.4rem'};
  margin: ${props => props.margin};
  cursor: pointer;
`;

export default CompletedActiveIcon;
